
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  props: {
    max: {
      type: Number,
      default: 1,
    },
    value: {
      type: Number,
      default: 0,
    },
    text: String,
    notext: Boolean,
  },
  methods: {
    getWidth() {
      return `width: ${this.getPercentageText()} !important;`;
    },
    getPercentageText() {
      const percent = this.getRatio() * 100;
      if (percent % 1 == 0) return `${percent}%`;
      else return `${percent.toFixed(2)}%`;
    },
    getRatio(): number {
      let pct = this.value / this.max;
      pct = pct > 1 ? 1 : pct < 0 ? 0 : pct;
      return pct;
    },
  },
});
